var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "family-list tongxin-layout"
  }, [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("請選擇家庭成員")]), _c('div', {
    staticClass: "section mb-4"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("已授權")]), _c('OptionList', {
    attrs: {
      "items": _vm.authorizedProfiles,
      "selected": _vm.selectedProfileId
    },
    on: {
      "update:selected": function updateSelected(value) {
        return _vm.updateSelectedProfile(value, 'auth');
      }
    }
  })], 1), _c('div', {
    staticClass: "section"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("未授權")]), _c('OptionList', {
    attrs: {
      "items": _vm.unauthorizedProfiles,
      "selected": _vm.selectedProfileId
    },
    on: {
      "update:selected": function updateSelected(value) {
        return _vm.updateSelectedProfile(value, 'family');
      }
    }
  })], 1), _vm.relations.length === 0 && !_vm.isLoading ? _c('div', {
    staticClass: "empty-state"
  }, [_c('p', [_vm._v("尚無親友資料")])]) : _vm._e(), _vm.isFromSetting ? _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "add-family",
    on: {
      "click": _vm.goToAddMember
    }
  }, [_vm._v(" + 新增家庭成員 ")])]) : _vm._e(), _c('div', {
    staticStyle: {
      "padding-bottom": "96px"
    }
  }), _c('div', {
    staticClass: "fixed-footer-navigation"
  }, [_c('TongxinNavigation', {
    attrs: {
      "canProceed": _vm.selectedProfileId !== null,
      "backButtonIsVisible": true,
      "nextButtonIsVisible": true,
      "textForNextStep": "下一步"
    },
    on: {
      "back": _vm.handleBack,
      "next": _vm.handleNext
    }
  })], 1), _vm.isLoading ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }